import * as React from 'react';

import { FilterItemCheckbox, Text } from '@notino/react-styleguide';

import { useTrackingContext } from '@context/tracking/TrackingContext';

import {
  useReviewFilterActions,
  useReviewFiltersStore,
} from '../../../Stores/filtersStore';
import { trackFiltration } from '../../tracking';

import { CountriesFilterContentWrapper } from './styled';

export const CountriesFilterContent: React.FC = () => {
  const shops = useReviewFiltersStore((state) => state.filtersData)?.shops;

  const selections = useReviewFiltersStore(
    (state) => state.temporarySelections
  );
  const { toggleSelection } = useReviewFilterActions();

  const { getTimeFromInit } = useTrackingContext();

  if (!shops?.length) {
    return null;
  }

  const onChange = (id: string) => {
    toggleSelection(id);
    trackFiltration({
      interaction: 'click_add',
      timing: getTimeFromInit(),
      name: '',
      action: 'filtration_used',
      type: 'shop',
    });
  };

  return (
    <CountriesFilterContentWrapper>
      {shops
        .filter(({ count }) => (count ?? 0) > 0)
        .map(({ count, id }) => (
          <FilterItemCheckbox
            key={id}
            isChecked={selections.includes(id!)}
            onChange={() => onChange(id!)}
            count={count ?? undefined}
          >
            <Text typography="labelRegular400" color="text.secondary">
              {id}
            </Text>
          </FilterItemCheckbox>
        ))}
    </CountriesFilterContentWrapper>
  );
};
